import styled from 'styled-components';

export const StyledSidebar = styled.div`
  z-index: 1;
  box-shadow: ${({ theme }) => theme.vars.boxShadow.overlayMenu};
  padding: 4.5rem 4rem;
`;

export const NewStyledSidebar = styled.div`
  padding: 30px 34px;
  left: 110px;
  top: 45px;
  width: 360px;
  background: #f5f7fa;
  border-radius: 20px;
  height: 600px;
`;

export const SidebarHeaderContainer = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto;
  margin-bottom: 2.5rem;
  margin-left: -6px;
`;

export const HeaderWrapper = styled.div`
  margin-bottom: -1.5rem;
`;

export const SidebarList = styled.ul`
  padding: 0;
  margin: 0;
  list-style-type: none;
`;

export const SidebarListItem = styled.li`
  margin-bottom: 1rem;
`;

export const SidebarLabel = styled.div`
  display: inline-block;
  margin-right: 1rem;
`;

export const SidebarDates = styled.div<{ hasDate: boolean }>`
  display: inline-flex;
  align-items: center;
  margin-top: ${({ hasDate }) => (hasDate ? '1rem' : null)};
`;

export const TimezoneOffset = styled.span`
  display: inline-block;
  margin-left: 0.5rem;
  font-size: 1rem;
`;

export const LastEdited = styled.div`
  margin-top: 3.5rem;
  border-top: 1px dashed ${({ theme }) => theme.vars.newColor.darkGS3};
  padding-top: 2rem;
  font-style: italic;
`;

export const LinkIcon = styled.span`
  display: inline-block;
  margin-left: 1.5rem;
`;
